


















import { Component, Mixins, } from "vue-property-decorator";
import { DocumentEditor } from "../../editor/sign";
import { ExistingDocumentEditorMixin, } from "../mixins";
import LoadedDocumentPreprocessor from "../LoadedDocumentPreprocessor.vue";

@Component({
  components: {
    DocumentEditor,
    LoadedDocumentPreprocessor,
  }
})
export default class ExistingDocumentEditor extends Mixins(ExistingDocumentEditorMixin) {
}
